import { WORKSHOP_SCORE_DATA, UPDATE_WORKSHOP_SCORE_DATA } from "constants/api";
import axiosInstance from "helpers/axiosInstance";

// Types
export interface IWorkshopScoreDataAssessment {
  id: string;
  title: string;
  titleAr: string;
  typeName: string;
  typeNameAr: string;
}

export interface IWorkshopScoreDataEmployee {
  employeeId: string;
  employeeName: string;
  employeeNameAr: string;
  answers: IWorkshopScoreDataAnswer[];
}

export interface IWorkshopScoreDataAnswer {
  questionId: string;
  questionTitle: string;
  questionTitleAr: string;
  questionOrder: number;
  correctAnswer: string;
  correctAnswerAr: string;
  selectedAnswer: string;
  selectedAnswerAr: string;
  options: IWorkshopScoreDataOption[];
}

export interface IWorkshopScoreDataOption {
  id: string;
  description: string;
  descriptionAr: string;
  score: number;
  optionOrder: number;
}

export interface IUpdateWorkshopScoreDataRequest {
  workshopId: string;
  assessmentId: string;
  employeeAnswers: {
    employeeId: string;
    answers: {
      questionId: string;
      selectedOptionId: string;
    }[];
  }[];
}

// API Functions
export const getWorkshopScoreDataAssessments = async (workshopId: string): Promise<IWorkshopScoreDataAssessment[]> => {
  const response = await axiosInstance.get(`${WORKSHOP_SCORE_DATA}/assessments?workshopId=${workshopId}`);
  return response.data;
};

export const getWorkshopScoreDataEmployees = async (
  workshopId: string, 
  assessmentId: string
): Promise<IWorkshopScoreDataEmployee[]> => {
  const response = await axiosInstance.get(
    `${WORKSHOP_SCORE_DATA}/employees?workshopId=${workshopId}&assessmentId=${assessmentId}`
  );
  return response.data;
};

export const updateWorkshopScoreData = async (data: IUpdateWorkshopScoreDataRequest): Promise<void> => {
  await axiosInstance.post(UPDATE_WORKSHOP_SCORE_DATA, data);
};
